<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
  class="dark bg-gray-900 print:hidden"
  [appearance]="'compact'"
  [mode]="isScreenSmall ? 'over' : 'side'"
  [name]="'mainNavigation'"
  [navigation]="navigation.compact"
  [opened]="!isScreenSmall"
  (openedChanged)="navigationOpened = $event"
>
  <!-- Navigation header hook -->
  <ng-container fuseVerticalNavigationContentHeader>
    <!-- The brand now lives in the top bar (see the header below). This full-height rail
             is a product / domain switcher (Overview, Voice, Rooms, Fleet, Cortex, Settings),
             so it deliberately carries no logo — just breathing room at the top. -->
    <div class="mt-4"></div>
  </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col">
  <!-- Header -->
  <div
    class="console-header bg-card relative z-49 flex h-16 w-full flex-none items-center px-4 shadow-sm dark:border-b dark:shadow-none md:px-6 print:hidden"
  >
    <!-- Navigation toggle — only shown when the rail is collapsed -->
    @if (!navigationOpened) {
      <button
        class="mr-1"
        mat-icon-button
        (click)="toggleNavigation('mainNavigation')"
      >
        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
      </button>
    }

    <!-- ODIN brand — full wordmark in the top bar (links home) -->
    <a
      class="ml-1 flex shrink-0 items-center"
      [routerLink]="'/'"
      aria-label="ODIN home"
    >
      <img class="h-10" src="images/logo/odin-logo-white.svg" alt="ODIN" />
    </a>

    <!-- App Selector (project switcher) -->
    <app-selector class="ml-4 min-w-0 sm:ml-8"></app-selector>
    <!-- Beside the project it describes, not in the right-hand cluster: the
         meter sums every product in this project, so it is a property of the
         selection next to it rather than one more tool icon. -->
    <resource-meter class="ml-3 hidden md:block"></resource-meter>
    <!-- Components -->
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2">
      <!-- Quick access. The palette also opens with Ctrl/⌘+K from anywhere;
                 this button is what makes that discoverable. -->
      <span class="hidden lg:block">
        <!-- One `gap` sets every distance in here. The spacing used to be
                     an `mr-3` *behind* the label, so the icon sat flush against
                     the text and the shortcut chip carried the only gap. -->
        <button
          mat-stroked-button
          class="console-field-button quick-access-button"
          (click)="openCommandPalette()"
          aria-label="Open quick access"
        >
          <mat-icon
            class="icon-size-5"
            [svgIcon]="'heroicons_outline:magnifying-glass'"
          ></mat-icon>
          <span class="text-secondary">Quick access</span>
          <span
            class="quick-access-shortcut text-secondary rounded-sm border px-1.5 py-0.5 text-xs leading-none"
          >
            {{ commandPaletteShortcut }}
          </span>
        </button>
      </span>
      <span class="lg:hidden">
        <button
          mat-icon-button
          (click)="openCommandPalette()"
          aria-label="Open quick access"
        >
          <mat-icon [svgIcon]="'heroicons_outline:magnifying-glass'"></mat-icon>
        </button>
      </span>
      <user></user>
    </div>
  </div>

  <!-- Content -->
  <div class="flex flex-auto flex-col">
    <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <div
    class="bg-card relative z-49 flex h-14 w-full flex-none items-center border-t px-4 md:px-6 print:hidden"
  >
    <span class="text-secondary font-medium"
      >4Players &copy; {{ currentYear }}</span
    >
  </div>
</div>
